/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ID } from '@/data/types/Basic';
import { ItnlIntegrationScript } from '@/data/types/ItnlIntegrationScript';
import { WidgetProperties } from '@/data/types/Slot';
import { flowboxScript } from '@/utils/itnlIntegrationScriptsScripts';
import { loadExternalScripts, removeScripts } from '@/utils/loadExternalScripts';
import { Box } from '@mui/material';
import { FC, useEffect } from 'react';

const emptyProperties: Partial<WidgetProperties> = {};
const page = "PDP";

export const FlowboxPdpRv: FC<{ id: ID; properties?: WidgetProperties }> = ({
	id,
	properties = emptyProperties,
}) => {
	const flowboxDynamicPDPKey = properties.flowKey;

	useEffect(() => {
		if (flowboxDynamicPDPKey && id.toString()) {
			let scripts: ItnlIntegrationScript[] = [{
				id: "flowbox_init_script",
				scriptContent: flowboxScript(flowboxDynamicPDPKey, page, id.toString()),
			}];

			loadExternalScripts(scripts);
			return () => { removeScripts(scripts) }
		}
	}, [flowboxDynamicPDPKey, id.toString()]);

	return <Box id="js-flowbox-flow_dynamic_pdp" className="flowBoxDiv"></Box>
};